"use client";

import React, { useState, useMemo } from "react";
import { Search, MapPin, ArrowRight } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
const PROMOTIONS_DATA = [{
  id: "promo-1",
  destination: "España, Brasil, USA, Italia",
  title: "Italia o España! PromoFlash!",
  description: "Europa está mas cerca! Con PromoFlash encontraras Promociones de vuelos para especificas fechas. En todo el mundo hasta un 40% menos.",
  price: "USD1199",
  image: "https://theperfectexperience.world/wp-content/uploads/2026/08/Milan-Italia.jpeg",
  tags: ["Promoflash", "Escapada", "vuelos"]
}, {
  id: "promo-2",
  destination: "Mexico",
  title: "Cancun o Playa del Carmen",
  description: "Descubre el caribe Mexicano. Disfruta de las playas y paseos con mas espacio sin gente, disfruta de temporada baja",
  price: "USD455",
  image: "https://theperfectexperience.world/wp-content/uploads/2026/08/chichen-itza-Cancun.jpg",
  tags: ["Mexico", "caribe", "Promo"]
}, {
  id: "promo-3",
  destination: "Santiago de Chile",
  title: "Santiago de Chile!",
  description: "2 noches de alojamiento c/des + traslado. Disfruta de esta hermosa ciudad en Chile. Disfruta de Santiago de Chile en todo su Explendor! Consulta tus fechas perfectas",
  price: "USD105",
  image: "https://theperfectexperience.world/wp-content/uploads/2026/08/Cajon-del-Maipo.jpg",
  tags: ["Playa", "Chile", "Vuelo", "barato", "santiago de chile"]
}, {
  id: "promo-4",
  destination: "Brasil",
  title: "Fiestas en Rio de Janeiro",
  description: "Rio te espera en Navidad y Año nuevo! Paquetes desde 849 usd p/p 6 dias! Playas increíbles, paisajes inolvidables y la energía única de una de las ciudades más famosas del mundo.  Consulta tus fechas perfectas.",
  price: "USD849",
  image: "https://theperfectexperience.world/wp-content/uploads/2026/08/image.png",
  tags: ["Brasil", "vuelos", "Rio de Janeiro", "Promo"]
}, {
  id: "promo-5",
  destination: "Cataratas",
  title: "Cataratas Terrestre",
  description: "Viví una experiencia única entre Argentina, Brasil y Paraguay con todo incluido y sin preocuparte de nada. Salimos todos los sabados dede MVD",
  price: "USD650",
  image: "https://golden-serval.10web.cloud/wp-content/uploads/2026/05/F6C9F665-6C1B-4A62-A658-2FB69FF9F965.png?v=asb5h49fvfk",
  tags: ["Cataratas", "Relajación", "terrestre", "grupos"]
}, {
  id: "promo-6",
  destination: "Buenos Aires",
  title: "Resitales en Buenos Aires",
  description: "Vive toda la musica en Buenos Aires este 2026! Artistas como Ed Sheeran, Rosalia, Maroon 5 y más! Contanos cual es tu artista favorito. Paquetes con Entrada seleccionada, traslados y alojamiento.",
  price: "USD385",
  image: "https://golden-serval.10web.cloud/wp-content/uploads/2026/05/16509CF2-A5FB-4E8A-A510-01EDB4EBF8EF.png?v=8sxmb75is4l",
  tags: ["Buenos Aires", "concierto", "recitales", "Shows"]
}, {
  id: "promo-9",
  destination: "Buenos Aires",
  title: "Buenos Aires con Colonia Express",
  description: "Vive toda la experencia en Buenos Aires! Pasajes ida y vuelta + 2 noches de Hotel con desayuno.",
  price: "USD155",
  image: "https://golden-serval.10web.cloud/wp-content/uploads/2026/06/Buenos_Aires_Arquitectura.jpg",
  tags: ["Buenos Aires", "colonia express", "hotel", "bsas"]
}, {
  id: "promo-7",
  destination: "USA Miami",
  title: "MIAMI",
  description: "Miami te espera!. Playas increíbles, compras, gastronomía, vida nocturna y el clima perfecto para una escapada inolvidable. Es el momento ideal para descubrir una de las ciudades más vibrantes de Estados Unidos y vivir experiencias únicas frente al mar.",
  price: "USD999",
  image: "https://theperfectexperience.world/wp-content/uploads/2026/08/image-1.png",
  tags: ["Miami", "USA", "vuelos", "promo"]
}, {
  id: "Promo-8",
  destination: "CRUCEROS",
  title: "Cruceros por el Mundo",
  description: "Salidas en 2026 y 2027! con descuentos para familias, comunicate y haz realidad tu viaje perfecto navegando por las aguas del mundo!",
  price: "USD964",
  image: "https://theperfectexperience.world/wp-content/uploads/2026/08/image-2.png",
  tags: ["Brasil", "crucero", "promo", "Mvd"]
}];
export default function SearchPromotions() {
  const [searchTerm, setSearchTerm] = useState("");
  const filteredPromotions = useMemo(() => {
    const lowerCaseTerm = searchTerm.toLowerCase().trim();
    if (!lowerCaseTerm) return PROMOTIONS_DATA;
    return PROMOTIONS_DATA.filter(promo => {
      return promo.destination.toLowerCase().includes(lowerCaseTerm) || promo.title.toLowerCase().includes(lowerCaseTerm) || promo.tags.some(tag => tag.toLowerCase().includes(lowerCaseTerm));
    });
  }, [searchTerm]);
  return <section id="search-promotions" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        
        {}
        <div className="flex flex-col items-center text-center mb-12 md:mb-16 space-y-6">
          <div className="space-y-3 max-w-2xl">
            <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground tracking-tight">
              Descubre <span className="text-primary">Promociones</span> Exclusivas
            </h2>
            <p className="text-muted-foreground text-lg">
              Encuentra la escapada perfecta. Busca por destino, tipo de experiencia o palabras clave para desbloquear ofertas de viaje especiales.
            </p>
          </div>

          <div className="w-full max-w-xl relative flex items-center">
            <div className="relative w-full flex items-center">
              <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 size-5 text-muted-foreground" />
              <Input type="text" placeholder="Buscar destinos, p. ej. 'París' o 'Playa'..." className="w-full pl-11 pr-24 h-14 text-base rounded-lg border-border bg-card shadow-sm focus-visible:ring-primary" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
              <Button className="absolute right-1.5 top-1/2 -translate-y-1/2 rounded-lg h-11 px-6" onClick={() => {}}>
                Buscar
              </Button>
            </div>
          </div>
        </div>

        {}
        {filteredPromotions.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {filteredPromotions.map((promo, index) => <Card key={promo.id} data-index={index} className="overflow-hidden flex flex-col border-border/50 shadow-md hover:shadow-lg transition-shadow duration-300 bg-card">
                <div className="relative h-56 w-full overflow-hidden">
                  <img src={promo.image} data-wvc-srcset={`${promo.image}-wvc-srcset`} data-wvc-sizes={`${promo.image}-wvc-sizes`} alt={promo.title} className="object-cover w-full h-full transition-transform duration-500 hover:scale-105" loading="lazy" />
                  <div className="absolute top-4 left-4 flex gap-2">
                    {promo.tags.map((tag, tagIndex) => <Badge key={tagIndex} data-index={tagIndex} variant="secondary" className="bg-background/90 backdrop-blur-sm text-foreground border-none shadow-sm">
                        {tag}
                      </Badge>)}
                  </div>
                </div>
                
                <CardHeader className="pb-3">
                  <div className="flex items-center gap-1.5 text-primary mb-2">
                    <MapPin className="size-4" />
                    <span className="text-sm font-medium">{promo.title}</span>
                  </div>
                  <CardTitle className="Promociones Flash"> 
                    {promo.title}
                  </CardTitle> 
                </CardHeader>
                
                <CardContent className="flex-grow pb-4">
                  <p className="text-muted-foreground text-sm line-clamp-3 !not-italic">
                    {promo.description}
                  </p>
                </CardContent>
                
                <CardFooter className="pt-0 flex items-center justify-between border-t border-border/40 mt-4 pb-5 px-6">
                  <div className="flex flex-col pt-4">
                    <span className="text-xs text-muted-foreground uppercase tracking-wider font-semibold">Desde</span>
                    <span className="text-2xl font-bold text-foreground font-default !not-italic">{promo.price}</span>
                  </div>
                  <Button asChild variant="outline" className="mt-4 border-primary text-primary hover:bg-primary hover:text-primary-foreground group">
                    <Link to={`https://www.instagram.com/viajeperfecto.traveluy?igsh=MW9sN3g3YjhscWttZw%3D%3D&utm_source=qr}`}>
                      Ver Oferta
                      <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>)}
          </div> : <div className="flex flex-col items-center justify-center py-20 text-center bg-card rounded-2xl border border-border border-dashed">
            <div className="bg-muted/50 p-4 rounded-lg mb-4">
              <Search className="size-8 text-muted-foreground" />
            </div>
            <h3 className="text-xl font-semibold font-default text-foreground mb-2">No se encontraron promociones</h3>
            <p className="text-muted-foreground max-w-md">
              No pudimos encontrar ofertas que coincidan con "{searchTerm}". Intenta ajustar tus términos de búsqueda o navega todas nuestras ofertas actuales.
            </p>
            <Button variant="outline" className="mt-6" onClick={() => setSearchTerm("")}>
              Borrar Búsqueda
            </Button>
          </div>}

      </div>
    </section>;
}